export default {
    en: {
        invalidLinkTitle: "Invalid Link",
        invalidLinkDescription: "The link you have used is invalid. Please check the link or contact the card owner for a new link.",
        callMe: "Toll Free",
        emailMe: "Email me",
        visitWebsite: "Visit me",
        followMe: "Follow me",
        saveContact: "Save contact",
        handleErrorMessage: "Invalid link. Please, contact support.",
        vCardErrorTitle: "Contact not available",
        vCardErrorMessage: "The contact you are trying to save is no longer available or has been removed.",
        savingContact: "Saving...",
        directLine: "Direct Line",
        mailingAddress: "Mailing Address",
        whatsapp: "WhatsApp"
    },
    es: {
        invalidLinkTitle: "Enlace no válido",
        invalidLinkDescription: "El enlace que has utilizado no es válido. Por favor, verifica el enlace o contacta al propietario de la tarjeta para obtener un nuevo enlace.",
        callMe: "Teléfono gratuito",
        emailMe: "Envíame un correo",
        visitWebsite: "Visítame",
        followMe: "Sígueme",
        saveContact: "Guardar Contacto",
        handleErrorMessage: "Enlace no válido. Por favor, contacta al soporte.",
        vCardErrorTitle: "Contacto no disponible",
        vCardErrorMessage: "El contacto que intentas guardar ya no está disponible o ha sido eliminado.",
        savingContact: "Guardando...",
        directLine: "Línea Directa",
        mailingAddress: "Dirección Postal",
        whatsapp: "WhatsApp"
    },
};